// Author Lin
// Date 2024-06-05 16:34:40

class SithMesInventoryCount {
    constructor({
                    id = null,
                    binId = '',
                    systemQuantity = '',
                    actualQuantity = '',
                    profitsOrLoss = '',
                    reasons = '',
                    financialConfirmed = '',
                    financialConfirmerId = '',
                    financialConfirmTime = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.binId = binId;
        this.systemQuantity = systemQuantity;
        this.actualQuantity = actualQuantity;
        this.profitsOrLoss = profitsOrLoss;
        this.reasons = reasons;
        this.financialConfirmed = financialConfirmed;
        this.financialConfirmerId = financialConfirmerId;
        this.financialConfirmTime = financialConfirmTime;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesInventoryCount();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'binId',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.binId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageBin',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.storageBin',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'material',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.material',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'systemQuantity',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.systemQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualQuantity',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.actualQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'profitsOrLoss',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.profitsOrLoss',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '盘盈'},
                    {value: '1', text: '持平'},
                    {value: '2', text: '盘亏'}
                ]
            }
        },
        {
            key: 'reasons',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.reasons',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'financialConfirmed',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.financialConfirmed',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'financialConfirmerId',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.financialConfirmerId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'confirmerName',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.confirmerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'financialConfirmTime',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.financialConfirmTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'countUser',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.countUser',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryCount.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    binIdFilter: '',
    storageBinFilter: '',
    materialFilter: '',
    systemQuantityFilter: '',
    actualQuantityFilter: '',
    profitsOrLossFilter: '',
    reasonsFilter: '',
    financialConfirmedFilter: '',
    financialConfirmerIdFilter: '',
    financialConfirmUserFilter: '',
    financialConfirmTimeRteFilter: '',
    financialConfirmTimeLteFilter: '',
    countUserFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'storageBinFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.storageBin',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'systemQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.systemQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.actualQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitsOrLossFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.profitsOrLoss',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '盘盈'},
                {value: '1', text: '持平'},
                {value: '2', text: '盘亏'}
            ]
        }
    },
    {
        key: 'reasonsFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.reasons',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'financialConfirmedFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.financialConfirmed',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'financialConfirmUserFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.financialConfirmUser',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'countUserFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.countUser',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryCount.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'binId',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.binId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'systemQuantity',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.systemQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualQuantity',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.actualQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitsOrLoss',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.profitsOrLoss',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '盘盈'},
                {value: '1', text: '持平'},
                {value: '2', text: '盘亏'}
            ]
        }
    },
    {
        key: 'reasons',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.reasons',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'financialConfirmed',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.financialConfirmed',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'financialConfirmerId',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.financialConfirmerId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'financialConfirmTime',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.financialConfirmTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryCount.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryCount, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
